import * as helpers from './helpers';
import validate from './validate';
import { lockFormFields, unlockFormFields, preparePaymentTaxFromForm } from './actions';
import { showPaymentStatus, preparePaymentStatus } from './status';
import { postPaymentTaxPrepare, getPaymentSend } from './api';
import { setStoragePaymentData } from './storage';
import { periodTypeChanged, addCommission, setEntityIdType, clearAccountField, resetEntityTypeBtns } from './actions';

const form = document.querySelector('.payment-tax-form');

export const handleSubmitForm = async (e) => {
    try {
        e.preventDefault();

        if (!validate(e.target)) return false;

        lockFormFields(e.target, true);

        const preparedData = preparePaymentTaxFromForm(e.target);

        const { data } = await postPaymentTaxPrepare(preparedData);
        if (!data.paymentUrl || !data.uuid || !data.token) {
            showPaymentStatus(preparePaymentStatus('CUSTOM_FAILUR_PREPARED_FEEDBACK_DATA'));
            throw new Error();
        }

        setStoragePaymentData(data.uuid, data.token);

        const { data: paymentUrl } = await getPaymentSend(data.uuid, data.token);
        if (!paymentUrl) {
            showPaymentStatus(preparePaymentStatus('FAILURE_SENT_FAILURE'));
            throw new Error();
        }

        window.location.href = paymentUrl;
    }
    catch (error) {
        if (error && error.message) showPaymentStatus(preparePaymentStatus('FAILURE_SENT_FAILURE'));
    }
    finally {
        unlockFormFields(e.target);
    }
}

export const handleInputChange = (e) => {
    // console.log('EVENT ALL', e.target.name, e.target);
    const { target } = e;
    if (typeof target.name === 'undefined' || !target.name) return false;

    if (target.name == 'period_type') periodTypeChanged(target);
    if (target.name == 'tax_amount') addCommission(target);
    validate(form, target.name);
}

export const handleEntityIdTypeChange = () => {
    setEntityIdType();
    clearAccountField();
}

export const handleEntityTypeChange = ({ target }) => {
    const select = form.querySelector('.id-type select');
    if (!form || !select) return false;

    const type = target.getAttribute('data-type');
    resetEntityTypeBtns();
    target.classList.add('btn-primary', 'active');
    helpers.resetErrors(form);

    if (typeof type !== 'undefined' && type) {
        const itemFieldsWrap = form.querySelector(`#${type}`);
        itemFieldsWrap.classList.remove('d-none');

        // Ukrywanie pola "Rodzaj identyfikatora"
        const idTypeGroup = form.querySelector('.id-type');
        if (idTypeGroup && type === 'person-data') idTypeGroup.classList.remove('d-none');
        else idTypeGroup.classList.add('d-none');

        if (type === 'person-data') select.value = 'pesel';
        else select.value = 'nip';

        setEntityIdType();
        clearAccountField();
    }
}
